import { TextField } from '@qbe/ads-core';
import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

import { useAppContent } from '~/hooks';
import { emailPattern } from '~/utils/constants';

const maxLength = 45;

const Email = <T extends FieldValues>({ control, name }: UseControllerProps<T>) => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.emailAddressComponent.fields.emailAddress',
  });

  return (
    <Controller
      name={name}
      control={control}
      rules={{ pattern: emailPattern, required: true, maxLength }}
      render={({ field: { ref, ...field }, fieldState }) => (
        <TextField
          {...field}
          id="email"
          inputRef={ref}
          label={getTextContent('label')}
          data-track="Email address"
          data-track-value="mask"
          helperText={
            fieldState.invalid ? getTextContent('invalidText') : getTextContent('helperText')
          }
          error={fieldState.invalid}
          displayIcon
          required
        />
      )}
    />
  );
};

export default Email;
